import mitt from 'mitt';
import { btnTd } from '@/api/typing';
import defaultSlotList from '@/components/page-model/slotList';
import { message, Modal } from 'ant-design-vue';
import { delete_product_in_cancel_record, get_product_in_record } from '@/api/mjstock-model';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import base_info from '@/components/info-modal/base_info_modal';

export const event_obj = mitt();
export const btn_list = [
  {
    name: '详情',
    type: 'dropdown',
    clazz: '',
    cb: (record: any) => {
      // 模态框，确认按钮点击。
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      get_product_in_record({
        org_id: current_org?.id,
        product_in_record_id: record.product_in_record_id,
      }).then(function (res: any) {
        base_info(
          '入库产品信息',
          '入库编号:' + res.code,
          [
            { name: '产品编号', value: 's_product__code' },
            { name: '产品名称', value: 's_product__name' },
            { name: '产品规格', value: 's_product__gg' },
            { name: '产品单位', value: 's_product__dw' },
            { name: '产品批次', value: 'product_code' },
            { name: '产品单价', value: 'single_price' },
            { name: '生产日期', value: 'product_date' },
            { name: '到期日期', value: 'end_date' },
            { name: '厂商', value: 'product_company__name' },
            { name: '供货商', value: 'supply_company__name' },
          ],
          res,
        );
      });
    },
  },
  {
    name: '作废',
    type: 'dropdown',
    clazz: 'danger',
    is_show: (record: any) => {
      return record.is_active && record.in_type != 3;
    },
    cb: (record: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      Modal.confirm({
        title: '提示',
        content: '是否作废这条记录[' + record.code + ']',
        onOk() {
          delete_product_in_cancel_record({
            product_in_cancel_record_id: record.id,
            org_id: current_org?.id,
          }).then(function (res) {
            message.success('作废成功');
            Object.assign(record, res);
          });
        },
        onCancel() {},
      });
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list: btnTd[] = [];
